import { ArrowRight as ArrowRightIcon } from "@/assets/icons/24/arrow/ArrowRight";
import { useGuestModalGuard } from "@/common/hooks/guest.hooks";
import { CREATE_AD_ROUTE } from "@/common/static/routes.static";
import { cn } from "@/common/utils/css.utils";
import { Button } from "@/ui/cva/Button";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { MouseEvent } from "react";

type CreateAdLinkProps = {
  outlined?: boolean;
  showIcon?: boolean;
  className?: string;
};

export const CreateAdLink = ({
  outlined,
  showIcon,
  className,
}: CreateAdLinkProps) => {
  const { t } = useTranslation();
  const { push } = useRouter();
  const { guestGuard } = useGuestModalGuard();

  const handleClick = async (evt: MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();

    const pass = await guestGuard({
      description: t("selling:selling-signup-login-wall-initial-desc"),
      referrer: "create-ad",
    });

    if (!pass) {
      return;
    }

    await push(CREATE_AD_ROUTE);
  };

  return (
    <Button
      appearance={outlined ? "outlined" : "solid"}
      rightIcon={
        showIcon ? <ArrowRightIcon className="size-6 shrink-0" /> : undefined
      }
      className={cn("w-max self-center md:self-start", className)}
      onClick={handleClick}
    >
      {t("selling:selling-create-an-ad-btn")}
    </Button>
  );
};
